import { render, staticRenderFns } from "./newHomePage.vue?vue&type=template&id=a15da302&scoped=true&"
import script from "./newHomePage.vue?vue&type=script&lang=js&"
export * from "./newHomePage.vue?vue&type=script&lang=js&"
import style0 from "./newHomePage.vue?vue&type=style&index=0&id=a15da302&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15da302",
  null
  
)

export default component.exports